import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

const footerLinks = [
  { href: '/homepage', label: '首頁' },
  { href: '/about', label: '關於我們' },
  { href: '/business-scope', label: '業務範圍' },
  { href: '/registration-center', label: '報名中心' },
  { href: '/contact', label: '聯繫我們' },
];

export default function Footer() {
  return (
    <footer className="bg-primary border-t border-white/10">
      <div className="max-w-container mx-auto px-6 lg:px-12 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo + Brand */}
          <div className="flex items-center gap-3">
            <AppLogo
              src="/assets/images/beb20884-3324-4758-9eef-42340ec5b17d-1773145188404.jpg"
              size={32}
            />
            <span className="font-heading text-sm font-600 text-white/80">
              Anri Interior Design Studio
            </span>
          </div>

          {/* Nav Links */}
          <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2">
            {footerLinks?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                className="font-body text-sm font-500 text-white/50 hover:text-white/90 transition-colors duration-200"
              >
                {link?.label}
              </Link>
            ))}
          </nav>

          {/* Contact */}
          <div className="flex items-center gap-4">
            <a
              href="mailto:macklavelle14@gmail.com"
              className="font-body text-sm text-white/50 hover:text-accent transition-colors duration-200"
            >
              macklavelle14@gmail.com
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-6 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono text-xs text-white/30">
            © 2025 安日室內設計工作室有限公司. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link href="/contact" className="font-mono text-xs text-white/30 hover:text-white/60 transition-colors">
              Privacy
            </Link>
            <Link href="/contact" className="font-mono text-xs text-white/30 hover:text-white/60 transition-colors">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}